function initProductCarousels(scope = document) {
  scope.querySelectorAll('.product-carousel').forEach(carousel => {
    // Avoid re-initializing the same carousel twice
    if (carousel.dataset.carouselInit === 'true') return;
    carousel.dataset.carouselInit = 'true';

    const track = carousel.querySelector('.product-carousel__track');
    const slides = carousel.querySelectorAll('.product-carousel__slide');
    const prevBtn = carousel.querySelector('.product-carousel__btn--prev');
    const nextBtn = carousel.querySelector('.product-carousel__btn--next');

    if (!track || slides.length <= 1) return;

    let index = 0;

    function update() {
      track.style.transform = `translateX(-${index * 100}%)`;
    }

    prevBtn?.addEventListener('click', e => {
      e.preventDefault();
      index = (index - 1 + slides.length) % slides.length;
      update();
    });

    nextBtn?.addEventListener('click', e => {
      e.preventDefault();
      index = (index + 1) % slides.length;
      update();
    });
  });
}

// Initialize on first load
document.addEventListener('DOMContentLoaded', () => {
  initProductCarousels();

  // Watch for dynamically added products (Prestige AJAX updates)
  const observer = new MutationObserver(mutations => {
    for (const mutation of mutations) {
      mutation.addedNodes.forEach(node => {
        if (!(node instanceof HTMLElement)) return;

        if (node.matches('.product-carousel') || node.querySelector('.product-carousel')) {
          initProductCarousels(node);
        }
      });
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});


  function replaceHeartIcons() {
  document.querySelectorAll('svg[data-icon="heart"]').forEach(oldSvg => {
    // Skip if already replaced
    if (oldSvg.parentElement?.querySelector('.bi-bookmark')) return;

    // --- Outline Bookmark SVG ---
    const svgOutline = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    svgOutline.setAttribute("xmlns", "http://www.w3.org/2000/svg");
    svgOutline.setAttribute("width", "16");
    svgOutline.setAttribute("height", "16");
    svgOutline.setAttribute("fill", "currentColor");
    svgOutline.setAttribute("class", "bi bi-bookmark");
    svgOutline.setAttribute("viewBox", "0 0 16 16");
    const pathOutline = document.createElementNS("http://www.w3.org/2000/svg", "path");
    pathOutline.setAttribute("d", "M2 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v13.5a.5.5 0 0 1-.777.416L8 13.101l-5.223 2.815A.5.5 0 0 1 2 15.5zm2-1a1 1 0 0 0-1 1v12.566l4.723-2.482a.5.5 0 0 1 .554 0L13 14.566V2a1 1 0 0 0-1-1z");
    svgOutline.appendChild(pathOutline);

    // --- Filled Bookmark SVG ---
    const svgFilled = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    svgFilled.setAttribute("xmlns", "http://www.w3.org/2000/svg");
    svgFilled.setAttribute("width", "16");
    svgFilled.setAttribute("height", "16");
    svgFilled.setAttribute("fill", "currentColor");
    svgFilled.setAttribute("class", "bi bi-bookmark-fill");
    svgFilled.setAttribute("viewBox", "0 0 16 16");
    const pathFilled = document.createElementNS("http://www.w3.org/2000/svg", "path");
    pathFilled.setAttribute("d", "M2 2v13.5a.5.5 0 0 0 .74.439L8 13.069l5.26 2.87A.5.5 0 0 0 14 15.5V2a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2");
    svgFilled.appendChild(pathFilled);

    // --- Replace the old heart with both icons ---
    const wrapper = document.createElement('span');
    wrapper.classList.add('bookmark-icons');
    wrapper.appendChild(svgOutline);
    wrapper.appendChild(svgFilled);

    oldSvg.replaceWith(wrapper);
  });
}

// Run initially on page load
replaceHeartIcons();

// Observe for dynamically added heart icons
const observer = new MutationObserver(() => replaceHeartIcons());
observer.observe(document.body, { childList: true, subtree: true });



/* Adding product from wishlist to cart    */

if (window.location.pathname.includes('/a/wishlist-hero/wishlist')) {
    
    const originalXHROpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function(method, url, ...rest) {        
        
        if (url.includes('cart/add')) {
                        
            this.addEventListener('load', function() {
                if (this.status >= 200 && this.status < 300) {
                                      
                    try {
                        const data = JSON.parse(this.responseText);
                      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
                      let cartTrigger = document.querySelector('[aria-controls="cart-drawer"]');
                      if (cartTrigger) {
                          cartTrigger.click();
                      }
                        
                    } catch (e) {
                        console.log("Response is not JSON or error parsing:", e);
                    }
                }
            });
        }
        
        return originalXHROpen.apply(this, [method, url, ...rest]);
    };
}